/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterLSmall = createReactComponent("letter-l-small", "IconLetterLSmall", [
  ["path", { d: "M10 8v8h4", key: "svg-0" }]
]);

export { IconLetterLSmall as default };
//# sourceMappingURL=IconLetterLSmall.js.map
